import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import BannerPage from '../../../components/BannerPage';
import Footer from '../../../components/Footer';
import '../../../App.css';
import ruesData from '../../../data/rues.json';

const Charcutiere = () => {
  const navigate = useNavigate();
  
  const handlePageClick = (link) => {
    navigate(link);
  };

  // Filtrer le tableau ruesData pour récupérer uniquement l'élément correspondant à "Bert"
  const chahoPage = ruesData.find((page) => page.name === "Chaho");
  const cordeliersPage = ruesData.find((page) => page.name === "Cordeliers");

  return (
    <div>
      <BannerPage>
        <div>
          <h2>Charcutière</h2>
          <h3>Histoire et photos des rues, monuments et ponts du petit Bayonne</h3>
        </div>
      </BannerPage>
      <div className="riverain-container">
        <div className="image-container2">
          <img src="https://i0.wp.com/www.bayonnades.fr/wp-content/uploads/2019/06/Rue-Charcutière.jpg?resize=799%2C524&ssl=1" alt="Rue Charcutière" className="riverain-image" />
          <figcaption>Rue Charcutière</figcaption>
        </div>
        <div className='apropos-content'>
          <h4>Rue CHARCUTIÉRE</h4>
          <p className='histoire'>
          Ancien nom : rue de Barad (du fossé)<br /> <br />
          On y vendait du lard gras – Changement de numérotation en 1855<br />   <br />
          </p>
        </div>
      </div>
      <div className="navigation-buttons">
        {/* Afficher le bouton seulement si l'élément correspondant existe */}
        {chahoPage && cordeliersPage && (
          <div className="riverain-buttons">
            <div className="riverain-item" onClick={() => handlePageClick(chahoPage.link)}>
              <Link to={chahoPage.link}>Page précédente</Link>
            </div>
            <div className="riverain-item" onClick={() => handlePageClick(cordeliersPage.link)}>
              <Link to={cordeliersPage.link}>Page suivante</Link>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};


export default Charcutiere;